(function () {
var userId = "42d5c6b7-1bd4-4276-82a8-389626021098";
var reviewsUrl = "https://api.okendo.io/v1/stores/" + userId + "/reviews";
var aggregateUrl = "https://api.okendo.io/v1/stores/" + userId + "/review_aggregate";
var rating = 5;
var limit = 25;
var totalReviewsNeeded = 50;

const fetchReviews = async () => {
  let allReviews = [];

  for (let page = 1; page <= totalReviewsNeeded / limit; page++) {
    const params = new URLSearchParams({
      page: page,
      limit: limit,
      orderBy: "date desc",
    });

    const fullUrl = `${reviewsUrl}?${params.toString()}`;

    try {
      const response = await fetch(fullUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // 'Authorization': 'Bearer YOUR_API_TOKEN' // if required
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const reviews = data.reviews || data;
      allReviews = allReviews.concat(reviews);
    } catch (error) {
      /* silent in production */
    }
  }

  // Filter reviews based on rating (5-star) and that have product URL and image
  const fiveStarReviews = allReviews.filter(
    (review) =>
      review.rating === rating && review.productUrl && review.productImageUrl
  );

  // If we have 5-star reviews, show them
  if (fiveStarReviews.length > 2) {
    await renderReviews(fiveStarReviews);
  }
  // If no 5-star reviews, show any reviews that have product URL and image
  else {
    const otherReviews = allReviews.filter(
      (review) => review.productUrl && review.productImageUrl
    );

    if (otherReviews.length > 0) {
      await renderReviews(otherReviews);
    }
  }
  waitForFlickity();
};

var renderReviews = function (reviews) {
  return new Promise(function (resolve) {
    var container = document.getElementById("dynamic-reviews-container");
    container.style.display = "flex";
    container.style.flexWrap = "wrap";
    container.style.gap = "20px";
    container.style.justifyContent = "center";

    var isMobile = window.innerWidth <= 790;
    var fragment = document.createDocumentFragment();

    for (var r = 0; r < reviews.length; r++) {
      var review = reviews[r];
      var timeDifference = getTimeDifference(new Date(review.dateCreated));

      var reviewCard = document.createElement("div");
      reviewCard.className = "review-card-custom";
      reviewCard.style.display = "flex";

      // Generate star rating HTML
      var starsHtml = "";
      for (var i = 1; i <= 5; i++) {
        if (i <= review.rating) {
          starsHtml += '<div class="star">★</div>';
        } else {
          starsHtml += '<div class="star" style="opacity: 0.5;">★</div>';
        }
      }

      // Create the review card HTML
      reviewCard.innerHTML = `
     <div class="review-card-user-review">   
     <div class="review-card-header">   
     <div class="review-card-author-image">
  ${
    review.reviewer.avatarUrl
      ? `
    <img
      src="${review.reviewer.avatarUrl}"
      width="48"
      height="48"
      loading="lazy"
      alt="${review.reviewer.displayName}"
      onerror="this.replaceWith(document.createRange().createContextualFragment(\`
            <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 25 25' fill='none'>
              <path d='M12.5 0.229187C14.0192 0.228722 15.4984 0.71523 16.7207 1.6173C17.943 2.51938 18.844 3.78951 19.2913 5.24127C19.7387 6.69303 19.7089 8.24997 19.2064 9.68356C18.7038 11.1172 17.7549 12.3519 16.499 13.2066C18.6789 14.0061 20.5696 15.4398 21.9278 17.323C23.286 19.2062 24.0494 21.4529 24.1199 23.7737C24.1264 23.9025 24.1072 24.0313 24.0634 24.1526C24.0195 24.2739 23.9518 24.3853 23.8644 24.4801C23.7769 24.5749 23.6714 24.6512 23.554 24.7047C23.4366 24.7582 23.3097 24.7877 23.1808 24.7915C23.0519 24.7953 22.9235 24.7733 22.8032 24.7268C22.6828 24.6803 22.573 24.6102 22.4801 24.5207C22.3873 24.4312 22.3132 24.324 22.2623 24.2055C22.2114 24.087 22.1846 23.9595 22.1837 23.8305C22.1067 21.3137 21.0529 18.9256 19.2453 17.1725C17.4378 15.4194 15.0187 14.4389 12.5007 14.4389C9.98263 14.4389 7.56353 15.4194 5.75602 17.1725C3.9485 18.9256 2.89462 21.3137 2.8177 23.8305C2.80999 24.0874 2.70053 24.3308 2.51341 24.507C2.32628 24.6832 2.07681 24.7779 1.81988 24.7702C1.56296 24.7625 1.31961 24.653 1.14339 24.4659C0.967162 24.2788 0.872489 24.0293 0.880197 23.7724C0.950913 21.4518 1.71448 19.2055 3.07262 17.3225C4.43077 15.4395 6.32134 14.006 8.50103 13.2066C7.24513 12.3519 6.29626 11.1172 5.7937 9.68356C5.29114 8.24997 5.26135 6.69303 5.70872 5.24127C6.15608 3.78951 7.05703 2.51938 8.27933 1.6173C9.50163 0.71523 10.9809 0.228722 12.5 0.229187ZM7.33336 7.33335C7.33336 8.70364 7.87771 10.0178 8.84664 10.9867C9.81558 11.9557 11.1297 12.5 12.5 12.5C13.8703 12.5 15.1845 11.9557 16.1534 10.9867C17.1224 10.0178 17.6667 8.70364 17.6667 7.33335C17.6667 5.96307 17.1224 4.64891 16.1534 3.67997C15.1845 2.71103 13.8703 2.16669 12.5 2.16669C11.1297 2.16669 9.81558 2.71103 8.84664 3.67997C7.87771 4.64891 7.33336 5.96307 7.33336 7.33335Z' fill='black'/>
            </svg>\`))"
    >
  `
      : `
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 25 25" fill="none">
      <path d="M12.5 0.229187C14.0192 0.228722 15.4984 0.71523 16.7207 1.6173C17.943 2.51938 18.844 3.78951 19.2913 5.24127C19.7387 6.69303 19.7089 8.24997 19.2064 9.68356C18.7038 11.1172 17.7549 12.3519 16.499 13.2066C18.6789 14.0061 20.5696 15.4398 21.9278 17.323C23.286 19.2062 24.0494 21.4529 24.1199 23.7737C24.1264 23.9025 24.1072 24.0313 24.0634 24.1526C24.0195 24.2739 23.9518 24.3853 23.8644 24.4801C23.7769 24.5749 23.6714 24.6512 23.554 24.7047C23.4366 24.7582 23.3097 24.7877 23.1808 24.7915C23.0519 24.7953 22.9235 24.7733 22.8032 24.7268C22.6828 24.6803 22.573 24.6102 22.4801 24.5207C22.3873 24.4312 22.3132 24.324 22.2623 24.2055C22.2114 24.087 22.1846 23.9595 22.1837 23.8305C22.1067 21.3137 21.0529 18.9256 19.2453 17.1725C17.4378 15.4194 15.0187 14.4389 12.5007 14.4389C9.98263 14.4389 7.56353 15.4194 5.75602 17.1725C3.9485 18.9256 2.89462 21.3137 2.8177 23.8305C2.80999 24.0874 2.70053 24.3308 2.51341 24.507C2.32628 24.6832 2.07681 24.7779 1.81988 24.7702C1.56296 24.7625 1.31961 24.653 1.14339 24.4659C0.967162 24.2788 0.872489 24.0293 0.880197 23.7724C0.950913 21.4518 1.71448 19.2055 3.07262 17.3225C4.43077 15.4395 6.32134 14.006 8.50103 13.2066C7.24513 12.3519 6.29626 11.1172 5.7937 9.68356C5.29114 8.24997 5.26135 6.69303 5.70872 5.24127C6.15608 3.78951 7.05703 2.51938 8.27933 1.6173C9.50163 0.71523 10.9809 0.228722 12.5 0.229187ZM7.33336 7.33335C7.33336 8.70364 7.87771 10.0178 8.84664 10.9867C9.81558 11.9557 11.1297 12.5 12.5 12.5C13.8703 12.5 15.1845 11.9557 16.1534 10.9867C17.1224 10.0178 17.6667 8.70364 17.6667 7.33335C17.6667 5.96307 17.1224 4.64891 16.1534 3.67997C15.1845 2.71103 13.8703 2.16669 12.5 2.16669C11.1297 2.16669 9.81558 2.71103 8.84664 3.67997C7.87771 4.64891 7.33336 5.96307 7.33336 7.33335Z" fill="black"/>
    </svg>
  `
  }
</div>
          <div class="review-card-author-info">
            <div class="review-card-author-name">${review.reviewer.displayName}</div>
            <div class="review-card-buyer-badge">${
              review.reviewer.isVerified
                ? 'Verified Buyer <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" style="vertical-align: middle; margin-left: 8px;"><g clip-path="url(#clip0_8_4113)"><path d="M8 16.3901C6.89583 16.3901 5.85938 16.1818 4.89062 15.7651C3.91146 15.3485 3.0599 14.7782 2.33594 14.0542C1.61198 13.3302 1.04167 12.4787 0.625 11.4995C0.208333 10.5308 0 9.4943 0 8.39014C0 7.28597 0.208333 6.24951 0.625 5.28076C1.04167 4.30159 1.61198 3.45003 2.33594 2.72607C3.0599 2.00212 3.91146 1.4318 4.89062 1.01514C5.85938 0.59847 6.89583 0.390137 8 0.390137C9.10417 0.390137 10.1406 0.59847 11.1094 1.01514C12.0885 1.4318 12.9401 2.00212 13.6641 2.72607C14.388 3.45003 14.9583 4.30159 15.375 5.28076C15.7917 6.24951 16 7.28597 16 8.39014C16 9.4943 15.7917 10.5308 15.375 11.4995C14.9583 12.4787 14.388 13.3302 13.6641 14.0542C12.9401 14.7782 12.0885 15.3485 11.1094 15.7651C10.1406 16.1818 9.10417 16.3901 8 16.3901ZM11.4531 4.81201L6.71875 9.53076L4.46875 7.29639L3 8.76514L6.71875 12.4683L12.9219 6.28076L11.4531 4.81201Z" fill="black"/></g><defs><clipPath id="clip0_8_4113"><rect width="16" height="16" fill="white" transform="matrix(1 0 0 -1 0 16.3901)"/></clipPath></defs></svg>'
                : "Buyer"
            }</div>
          </div>
          <div class="review-card-time">${timeDifference}</div>
        </div>

        <div class="review-card-stars">
          ${starsHtml}
        </div>

        <div class="review-card-title">${review.title || ""}</div>

        <div class="review-card-content">
          ${review.body || ""}
        </div>
        </div>
        
        <div class="review-card-product-details">
          <div class="review-card-product">
            <div class="review-card-product-image">
              <img
                src="${review.productImageUrl}"
                width="50"
                height="50"
                alt="${review.productName}"
                loading="lazy"
              >
            </div>
            <div class="review-card-product-name">${review.productName}</div>
          </div>
          <a href="${review.productUrl}" class="product-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M14.25 6.44249C14.25 6.85671 14.5858 7.19249 15 7.19249C15.4142 7.19249 15.75 6.85671 15.75 6.44249H14.25ZM9.55555 0.248047C9.14134 0.248047 8.80555 0.583833 8.80555 0.998047C8.80555 1.41226 9.14134 1.74805 9.55555 1.74805V0.248047ZM14.8813 1.59259L15.5496 1.2521L15.5496 1.2521L14.8813 1.59259ZM14.4055 1.11673L14.746 0.448474V0.448474L14.4055 1.11673ZM14.4414 2.61727C14.7343 2.32437 14.7343 1.8495 14.4414 1.55661C14.1485 1.26371 13.6737 1.26371 13.3808 1.55661L14.4414 2.61727ZM7.46967 7.46772C7.17678 7.76061 7.17678 8.23548 7.46967 8.52838C7.76256 8.82127 8.23744 8.82127 8.53033 8.52838L7.46967 7.46772ZM2.44775 14.709L2.78825 14.0408H2.78824L2.44775 14.709ZM1.289 13.5503L0.620743 13.8908H0.620743L1.289 13.5503ZM12.3777 13.5503L11.7094 13.2098L12.3777 13.5503ZM11.2189 14.709L10.8784 14.0408L11.2189 14.709ZM2.44775 3.62038L2.10726 2.95212V2.95212L2.44775 3.62038ZM1.289 4.77913L0.620743 4.43864H0.620743L1.289 4.77913ZM6.83333 4.08138C7.24755 4.08138 7.58333 3.74559 7.58333 3.33138C7.58333 2.91717 7.24755 2.58138 6.83333 2.58138V4.08138ZM13.4167 9.16471C13.4167 8.7505 13.0809 8.41471 12.6667 8.41471C12.2525 8.41471 11.9167 8.7505 11.9167 9.16471H13.4167ZM15.75 6.44249V2.74027H14.25V6.44249H15.75ZM13.2578 0.248047H9.55555V1.74805H13.2578V0.248047ZM15.75 2.74027C15.75 2.44773 15.7506 2.18321 15.7327 1.96401C15.714 1.73606 15.6718 1.49191 15.5496 1.2521L14.2131 1.93308C14.2096 1.9262 14.2266 1.95097 14.2377 2.08616C14.2494 2.23011 14.25 2.42298 14.25 2.74027H15.75ZM13.2578 1.74805C13.5751 1.74805 13.7679 1.74863 13.9119 1.76039C14.0471 1.77144 14.0719 1.78849 14.065 1.78498L14.746 0.448474C14.5061 0.326282 14.262 0.283998 14.034 0.265373C13.8148 0.247464 13.5503 0.248047 13.2578 0.248047V1.74805ZM15.5496 1.2521C15.3733 0.906091 15.092 0.624776 14.746 0.448474L14.065 1.78498C14.1287 1.81747 14.1806 1.86931 14.2131 1.93308L15.5496 1.2521ZM13.3808 1.55661L7.46967 7.46772L8.53033 8.52838L14.4414 2.61727L13.3808 1.55661ZM8.42424 14.248H5.24242V15.748H8.42424V14.248ZM1.75 10.7556V7.5738H0.25V10.7556H1.75ZM5.24242 14.248C4.48756 14.248 3.96651 14.2475 3.56199 14.2144C3.16622 14.1821 2.94849 14.1224 2.78825 14.0408L2.10726 15.3773C2.51421 15.5847 2.95131 15.6695 3.43984 15.7094C3.91961 15.7486 4.51231 15.748 5.24242 15.748V14.248ZM0.25 10.7556C0.25 11.4857 0.249417 12.0784 0.288616 12.5582C0.32853 13.0467 0.413394 13.4838 0.620743 13.8908L1.95725 13.2098C1.8756 13.0496 1.81597 12.8318 1.78363 12.4361C1.75058 12.0315 1.75 11.5105 1.75 10.7556H0.25ZM2.78824 14.0408C2.43045 13.8585 2.13956 13.5676 1.95725 13.2098L0.620743 13.8908C0.946858 14.5308 1.46722 15.0512 2.10726 15.3773L2.78824 14.0408ZM11.9167 10.7556C11.9167 11.5105 11.9161 12.0315 11.883 12.4361C11.8507 12.8318 11.7911 13.0496 11.7094 13.2098L13.0459 13.8908C13.2533 13.4838 13.3381 13.0467 13.3781 12.5582C13.4172 12.0784 13.4167 11.4857 13.4167 10.7556H11.9167ZM8.42424 15.748C9.15436 15.748 9.74706 15.7486 10.2268 15.7094C10.7154 15.6695 11.1525 15.5847 11.5594 15.3773L10.8784 14.0408C10.7182 14.1224 10.5004 14.1821 10.1047 14.2144C9.70016 14.2475 9.17911 14.248 8.42424 14.248V15.748ZM11.7094 13.2098C11.5271 13.5676 11.2362 13.8585 10.8784 14.0408L11.5594 15.3773C12.1994 15.0512 12.7198 14.5308 13.0459 13.8908L11.7094 13.2098ZM5.24242 2.58138C4.51231 2.58138 3.91961 2.5808 3.43984 2.62C2.95131 2.65991 2.51421 2.74477 2.10726 2.95212L2.78825 4.28863C2.94849 4.20698 3.16622 4.14735 3.56199 4.11501C3.96651 4.08196 4.48755 4.08138 5.24242 4.08138V2.58138ZM1.75 7.5738C1.75 6.81894 1.75058 6.29789 1.78363 5.89337C1.81597 5.4976 1.8756 5.27987 1.95725 5.11963L0.620743 4.43864C0.413394 4.84559 0.32853 5.28269 0.288616 5.77122C0.249417 6.25099 0.25 6.84369 0.25 7.5738H1.75ZM2.10726 2.95212C1.46722 3.27824 0.946858 3.7986 0.620743 4.43864L1.95725 5.11963C2.13956 4.76183 2.43045 4.47094 2.78825 4.28863L2.10726 2.95212ZM5.24242 4.08138H6.83333V2.58138H5.24242V4.08138ZM11.9167 9.16471V10.7556H13.4167V9.16471H11.9167Z" fill="black"/>
            </svg>
          </a>
        </div>
        </div>
      `;

      fragment.appendChild(reviewCard);
    }

    container.appendChild(fragment);
    resolve();
  });
};

var getTimeDifference = function (date) {
  var now = new Date();
  var diff = now - date;

  var minutes = Math.floor(diff / 60000);
  var hours = Math.floor(diff / 3600000);
  var days = Math.floor(diff / 86400000);
  var months = Math.floor(days / 30);

  if (months > 0) {
    return `${months} mo`;
  } else if (days > 0) {
    return `${days} d`;
  } else if (hours > 0) {
    return `${hours} h`;
  } else {
    return `${minutes} min`;
  }
};

var fetchAggregate = async function () {
  try {
    var response = await fetch(aggregateUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer YOUR_API_TOKEN' // if required
      },
    });

    if (!response.ok) {
      throw new Error(
        `HTTP error on /review_aggregate! status: ${response.status}`
      );
    }

    var data = await response.json();
    var reviewRatingValuesTotal =
      data.reviewAggregate.reviewRatingValuesTotal;
    var reviewCount = data.reviewAggregate.reviewCount;

    var averageRating = reviewRatingValuesTotal / reviewCount;

    var ratingSummary = document.getElementById("rating-summary");
    var averageRatingDisplay = document.getElementById(
      "average-rating-display"
    );
    var averageRatingStars = document.getElementById("average-rating-stars");
    var reviewCountDisplay = document.getElementById("review-count-display");

    if (
      ratingSummary &&
      averageRatingDisplay &&
      averageRatingStars &&
      reviewCountDisplay
    ) {
      var formattedRating = averageRating.toFixed(1);
      averageRatingDisplay.textContent = `${formattedRating} out of 5 stars`;

      var starsHtml = "";
      for (var i = 1; i <= 5; i++) {
        if (i <= Math.floor(averageRating)) {
          // Full star
          starsHtml +=
            '<div class="star" style="color: #F9A826; font-size: 20px; margin-right: 5px;">★</div>';
        } else if (i === Math.ceil(averageRating) && averageRating % 1 >= 0.3) {
          // Half star (for ratings with decimal 0.3 or higher)
          starsHtml +=
            '<div class="star" style="color: #F9A826; font-size: 20px; margin-right: 5px; position: relative;">★</div>';
        } else {
          // Empty star
          starsHtml +=
            '<div class="star" style="color: #F9A826; opacity: 0.5; font-size: 20px; margin-right: 5px;">★</div>';
        }
      }
      averageRatingStars.innerHTML = starsHtml;

      var formattedReviewCount = reviewCount.toLocaleString();
      reviewCountDisplay.textContent = `(Based on ${formattedReviewCount} reviews)`;

      var skeletonLine = document.querySelector(".skeleton-line");
      if (skeletonLine) skeletonLine.style.display = "none";
      ratingSummary.style.display = "block";
    }

  } catch (error) {
    /* silent in production */
  }
};

fetchReviews();
fetchAggregate();

/* Debounced resize listener — avoids destroying/recreating Flickity on every pixel */
var resizeTimer;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    if (typeof _Flickity !== "undefined") {
      var flkty = _Flickity.data(
        document.querySelector("#dynamic-reviews-container")
      );
      if (flkty) {
        flkty.destroy();
        window.initializeFlickity();
      }
    }
  }, 250);
});

})();
